import type { UserDocType } from '@ast-data/shared';

/** Names compare the way the app matches them: trimmed and case-folded. */
function normalize(name: string): string {
    return (name || '').trim().toLowerCase();
}

/**
 * The names already in the data that are still worth OFFERING.
 *
 * A person field is free text with suggestions, and the suggestions are the
 * accounts plus whatever the records already say — which is what keeps a
 * subcontractor without an account reachable. The catch is that a wrong value
 * feeds itself: once `P.Eichelbrönner` was stored, every later day offered it
 * again beside the `P. Eichelbrönner` the same account is spelled with.
 *
 * So a used name is dropped when it is the LOGIN NAME of an account the app
 * spells differently — the one case where the historic value is known to be a
 * worse way of writing somebody already in the list. Every other name stays.
 */
export function withoutLoginNames(
    used: readonly string[],
    users: readonly UserDocType[],
    label: (user: UserDocType) => string
): string[] {
    const shadowed = new Set<string>();
    for (const user of users) {
        const name = normalize(label(user));
        const login = normalize(user.username);
        if (name && login && name !== login) {
            shadowed.add(login);
        }
    }
    return used.filter((name) => !shadowed.has(normalize(name)));
}
